import SidebarContext from 'state/SidebarContext';
import { useContext, useEffect } from 'react';
import pulseClient from 'resources/pulse';
import ContactSeller from './ContactSeller';
import FiksFerdigInfo from './DataDropdown/FiksFerdigInfo';
import SafePaymentInfo from './DataDropdown/SafePaymentInfo';
import ShippingInfo from './DataDropdown/ShippingInfo';
import PaymentSection from './PaymentSection';
import PriceTag from './PriceTag';
import Tag from './Tag';

const FiksFerdig = () => {
    const { finnkode, uiText } = useContext(SidebarContext);
    const { callout, shippingInfo, serviceInfo, safePaymentInfo } = uiText.sections.sidebar.optedIn;

    useEffect(() => {
        pulseClient.trackViewButton(finnkode);
    });

    return (
        <>
            <section
                className="md:border rounded-8 border-bluegray-200 relative"
                aria-label="Kjøp varen"
            >
                <Tag label={callout} />
                <div className="pb-32 md:p-24">
                    <PriceTag />
                    <PaymentSection />
                </div>

                <FiksFerdigInfo serviceInfo={serviceInfo} />
                <ShippingInfo shippingInfo={shippingInfo} />
                <SafePaymentInfo safePaymentInfo={safePaymentInfo} />
            </section>
            <ContactSeller />
        </>
    );
};

export default FiksFerdig;
